module.exports = __webpack_public_path__ + "assets/ic-nova.5ffda5a0.svg";